class MegaMenuOpener extends HTMLElement {
  constructor() {
    super();

    this.closeTimeout = null;
    this.openTimeout = null;
    this.details = this.querySelector("details");
    this.summary = this.querySelector("summary");
    this.content = this.querySelector("[data-mega-menu-content]");

    this.lastMousePosition = null;

    this.handleMousemove = (e) => {
      this.newMousePosition = {
        y: e.pageY,
        x: e.pageX,
        time: Date.now(),
      };

      if (this.lastMousePosition) {
        this.velocity =
          ((this.newMousePosition.y - this.lastMousePosition.y) + (this.newMousePosition.x - this.lastMousePosition.x)) /
          (this.newMousePosition.time - this.lastMousePosition.time);
      }

      this.lastMousePosition = this.newMousePosition;
    };

    document.addEventListener("mousemove", this.handleMousemove);

    this.addEventListener("mouseover", () => {
      if (!isFinite(this.velocity)) return;

      if (Math.abs(this.velocity) > 0.01) {
        if (this.openTimeout) return;

        this.openTimeout = setTimeout(() => {
          this._open();
        }, 100);
      } else {
        this._open();
      }
    });

    this.addEventListener("click", (e) => {
      if (this.summary.contains(e.target)) {
        e.preventDefault();
        this.details.open ? this._close() : this._open();
      }
    });

    this.addEventListener("mouseleave", () => {
      this._close();
    });

    this.addEventListener("focusout", (e) => {
      if (this.contains(e.relatedTarget)) return;

      this._close();
    });

    this.closeEsc = (e) => {
      if (e.key === "Escape" && this.details.open) {
        this._close();
        this.summary.focus();
      }
    };

    document.addEventListener("keydown", this.closeEsc);
  }

  disconnectedCallback() {
    document.removeEventListener("keydown", this.closeEsc);
    document.removeEventListener("mousemove", this.handleMousemove);
  }

  _open() {
    clearTimeout(this.closeTimeout);
    clearTimeout(this.openTimeout);
    this.removeEventListener("transitionend", this.onEnd);
    this.openTimeout = null;
    this.details.open = true;
    this.details.classList.add("open");
    window.openDimmer(this);
    this.dispatchEvent(new CustomEvent("menu:open", { bubbles: true }));
  }

  _close() {
    clearTimeout(this.closeTimeout);
    clearTimeout(this.openTimeout);
    this.removeEventListener("transitionend", this.onEnd);
    this.openTimeout = null;

    this.closeTimeout = setTimeout(() => {
      this.dispatchEvent(new CustomEvent("menu:close", { bubbles: true }));
      this.details.classList.remove("open");
      window.closeDimmer(this);
      this.onEnd = () => {
        this.removeEventListener("transitionend", this.onEnd);

        if (this.classList.contains("open")) return;
        this.details.open = false;
      };
      this.addEventListener("transitionend", this.onEnd);
    }, 350);
  }
}

if (!customElements.get("mega-menu-opener")) {
  customElements.define("mega-menu-opener", MegaMenuOpener);
}
